<template>
  <div class="jersey-numbers-preview">
    <div class="jersey-numbers-preview__box" :style="{ backgroundColor: selection }">
      <span :class="previewStyle" :style="{ color: currentColor }">
        <span>12345</span>
        <div class="jersey-numbers-preview__sep"></div>
        <span>67890</span>
      </span>
    </div>
    <p class="jersey-numbers-preview__label">Change Background Color</p>
    <ColorPicker :value="selection" :colors="colors" @change="handleSelect" />
    <p class="jersey-numbers-preview__info-text">Preview Only: Background Color Won't Be Printed</p>
  </div>
</template>

<script setup>
import { ref, computed, watchEffect } from "vue";
import ColorPicker from "components/jiffy/vue-product-details-dtf/ColorPicker.vue";
import { useDtfStore } from "../store";

const colors = [
  "#000000",
  "#FFFFF0",
  "#4169E1",
  "#DC143C",
  "#228B22",
  "#671EA1",
  "#708090",
  "#FFD700",
  "#191970",
  "#800020"
];

const store = useDtfStore();
const letterNumberArtwork = computed(() => store.letterNumberArtwork);
const currentColor = computed(() => letterNumberArtwork.value.color || "#FFFFFF");
const previewStyle = computed(() => ({
  "jersey-numbers-preview__numbers": true,
  [`jersey-numbers-preview__numbers--${letterNumberArtwork.value.style}`]: true
}));

const touched = ref(false);
const selection = ref();

watchEffect(() => {
  if (!touched.value) {
    selection.value = currentColor.value === "#FFFFFF" ? "#000000" : "#FFFFF0";
  }
});

const handleSelect = color => {
  touched.value = true;
  selection.value = color;
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.jersey-numbers-preview {
  &__box {
    height: 182px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__sep {
    display: none;

    @include with-tablet {
      display: block;
      margin-bottom: 5px;
    }

    @include with-large-desktop {
      display: none;
    }
  }

  &__numbers {
    display: inline-block;
    font-family: "Emilio 20";
    font-size: 36px;
    line-height: 1;
    margin-top: -8px;

    $font-families: (
      "solid": "Emilio 19",
      "outline": "Emilio 20",
      "promesh": "Promesh",
      "niconne": "Niconne",
      "squares-bold": "Squares Bold",
      "beantown": "Beantown",
      "octin-sports": "Oction Sports",
      "soccer-league": "Soccer League",
      "rueckwarzsalto": "Rueckwarzsalto",
      "facon": "Facon",
      "varsity-team": "Varsity Team"
    );

    @each $modifier, $font-family in $font-families {
      &--#{$modifier} {
        font-family: quote(#{$font-family});
      }
    }

    @include with-tablet {
      font-size: 65px;
      margin-top: -12px;
    }
  }

  &__label {
    margin: 20px 0;
    color: $text-black;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.1;
  }

  &__info-text {
    margin: 15px 0 5px;
    color: $text-black;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.1;
    font-style: italic;
  }

  .color-picker__modal {
    @include with-tablet {
      top: auto;
      left: auto;
      margin-left: unset;
    }
  }
}
</style>
